// ============================================================================
// Featured Products - Shared Utilities
// ============================================================================

/**
 * Calculate percentage savings between sale price and original price.
 * Returns null if savings cannot be determined or sale >= original.
 */
export function calculateSavings(
  salePrice?: number | null,
  originalPrice?: number | null
): number | null {
  if (!salePrice || !originalPrice || salePrice >= originalPrice) return null
  const savings = ((originalPrice - salePrice) / originalPrice) * 100
  return Math.round(savings)
}

/**
 * Format a price value as USD currency string.
 * Returns 'N/A' for null/undefined values.
 */
export function formatPrice(price?: number | null): string {
  if (price == null) return '—'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(price)
}
